var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6882 6.6874C20.3133 8.19441 21.4001 9.9688 21.9141 11.2397C22.0286 11.514 22.0286 11.8196 21.9141 12.0939C21.4001 13.3335 20.3133 15.1079 18.6882 16.6462C17.0527 18.1671 14.8061 19.4449 12.0004 19.4449C9.19476 19.4449 6.94814 18.1671 5.31334 16.6462C3.68827 15.1079 2.60211 13.3335 2.08546 12.0939C1.97151 11.8196 1.97151 11.514 2.08546 11.2397C2.60211 9.9688 3.68827 8.19441 5.31334 6.6874C6.94814 5.16789 9.19476 3.88867 12.0004 3.88867C14.8061 3.88867 17.0527 5.16789 18.6882 6.6874ZM12.0004 6.66657C9.2399 6.66657 7.00022 8.90625 7.00022 11.6668C7.00022 14.4273 9.2399 16.667 12.0004 16.667C14.761 16.667 17.0007 14.4273 17.0007 11.6668C17.0007 8.90625 14.761 6.66657 12.0004 6.66657Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 11.6671,
    r: 3.37019,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.710bea30.svg";
export { ForwardRef as ReactComponent };